import Maqueta from "../Maqueta.js"
import Cercanias from "./Cercanias.js"
import gsap from 'gsap'
import { getItemDescriptor } from "@babel/core/lib/config/item.js"

export default class Interaccion {
    constructor() {
        this.maqueta = new Maqueta()
        this.cercanias = new Cercanias()
        this.mundo = this.maqueta.mundo
        this.materiales = this.maqueta.materiales
        this.camara = this.maqueta.camara
        this.inventario = this.maqueta.recursos.items.inventario
        //Elementos
        this.menuFlotante = document.getElementById('menuflotante')
        this.menuFlotanteBtns = this.menuFlotante.querySelectorAll('a')
        this.btnsCerrar = document.querySelectorAll('.btnCerrar-modal')
        this.btnFiltrar = document.getElementById('filtrar')
        this.btnLimpiarFiltros = document.getElementById('limpiar-filtros')
        this.modalUnidades = document.getElementById('modal-unidades')
        this.btnNuevaBusqueda = document.getElementById('btn-nueva-busqueda')
        this.btnCerrarBusqueda = this.modalUnidades.querySelector('.btnCerrar-modal')
        this.tablaResultados = document.querySelector('#resultados tbody')
        this.filasApto = document.querySelectorAll('.listado-resultados tbody tr')
        this.btnMostrarZonas = document.getElementById('btnZonas')
        //Modal hotspot zonas
        this.btnCerrarZonas = document.querySelector('#modal-zonas .btnCerrar-modal')
        this.modalHotspot = document.querySelector('#modal-hotspots')
        this.hotImg = this.modalHotspot.querySelector('.hotspot-img')
        this.hotLabel = this.modalHotspot.querySelector('.hotspot-label')
        this.hotspotZonasBtn = document.querySelectorAll('.hw-zonas .hotspot')
        this.elementosOcultosConZonasActivas = [
            //this.mundo.torre_4_baranda     

        ]
        this.infoZonas = [
            // LOBBY
            // SALÓN_COMUNAL
            // SOCIAL_KITCHEN
            // ZONA_DE_JUEGOS
            // GIMNASIO
            // PISCINA
            {
                name: 'LOBBY',
                label: 'Lobby',
                imagen: 'lobby.webp',
                posicion: {x: 0.10692119932655751, y: 0.29069851939060365, z: 2.6352504701257295}
            },
            {
                name: 'SALÓN_COMUNAL',
                label: 'Salón comunal',
                //imagen: 'bbq.webp',
                imagen: 'gris.webp',
                posicion: {x: 0.2761774202528452, y: 0.29069851939060337, z: 2.5819805281990695}
            },
            {
                name: 'SOCIAL_KITCHEN',
                label: 'Social kitchen',
                imagen: 'kitchen.webp',
                posicion: {x: -0.011252399722684471, y: 0.29069851939060337, z: 2.6440874833133043}
            },
            {
                name: 'GIMNASIO',
                label: 'Gimnasio',
                imagen: 'gym.webp',
                posicion: {x: 0.24484218153267917, y: 0.49208071676735926, z: 2.8559814160088903}
            },
            {
                name: 'PISCINA',
                label: 'Piscina',
                imagen: 'piscina.webp',
                posicion: {x: -0.10709170743128868, y: 0.48608432553682923, z: 2.746563475869017}
            },
            {
                name: 'ZONA_DE_JUEGOS',
                label: 'Zona de juegos',
                //imagen: 'fogata.webp',
                imagen: 'gris.webp',
                posicion: {x: -0.23208470252676489, y: 0.35712197804281093, z: 2.427105529245879}
            },   
            //ZONA_DE_JUEGOS          
        ]
        //
        this.listadoZonas = document.getElementById('listado-zonas')
        this.infoZonas.forEach(itemZona => {
            const li = document.createElement('li')
            li.dataset.name = itemZona.name
            li.innerHTML = itemZona.label
            this.listadoZonas.append(li)

            li.addEventListener('click', ()=>{
                this.mostrarZona(itemZona.name)
            })

        })
        
        //Temp cerrar modal zonas
        //Boton cerrar
        this.modalHotspot.querySelector('.btn-volver-hot').addEventListener('click', (event) => {
            event.preventDefault()
            this.modalHotspot.classList.remove('activo')

            /*const controles = this.camara.controles
            gsap.to(controles.target, {
                duration: 1,
                x: 0,
                y: 0.75,
                z: 0,
                onUpdate: function () {
                    controls.update();
                },
                onComplete: function () {
                    controls.enabled = true;
                    //Mostrar popup
                }
            });
            controls.minDistance = 4
            limpiarModalHot()*/
        })
        /*function limpiarModalHot() {
            hotImg.innerHTML = ''
            hotLabel.innerHTML = ''
        }*/
        //Tooltip y modal aptos
        this.tooltipApto = document.getElementById('tooltip-apto')
        this.tool_torre = this.tooltipApto.querySelector('.torre span')
        this.tool_apto = this.tooltipApto.querySelector('.apto span')
        this.tool_ac = this.tooltipApto.querySelector('.a-c span')
        this.tool_ap = this.tooltipApto.querySelector('.a-p span')
        this.tool_img = this.tooltipApto.querySelector('.tool-img')
        this.btnMostrarApto = document.querySelector('#tooltip-apto .btn-ir')
        this.btnCerrarTooltip = document.querySelector('#tooltip-apto .btn-cerrar')
        this.modalApto = {}
        this.modalApto.contenedor = document.querySelector('#modal-aptos')
        this.modalApto.apto_tit = document.querySelector('#modal-aptos h2')
        this.modalApto.pre_tit = document.querySelector('#modal-aptos .prefijo_tit')
        this.modalApto.suf_tit = document.querySelector('#modal-aptos .sufijo_tit')
        this.modalApto.area_ac = document.querySelector('#modal-aptos .area_ac span')
        this.modalApto.area_ap = document.querySelector('#modal-aptos .area_ap span')
        this.modalApto.area_b = document.querySelector('#modal-aptos .area_b span')
        this.modalApto.atributos = document.querySelector('#modal-aptos .atributos')
        this.modalApto.img_planta = document.querySelector('#modal-aptos .img_planta_contenedor')
        this.modalApto.btnVolver = document.querySelector('#modal-aptos .btn-volver-apto')
        this.modalApto.btnVolver.addEventListener('click', (event) => {
            event.preventDefault()
            this.modalApto.contenedor.classList.remove('activo')
            this.limpiarInfo()
        })


        //Menu flotante
        this.menuFlotanteBtns.forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault()
                const destino = document.querySelector(item.dataset.destino)
                if (destino) {
                    //Mostrar Pop up
                    destino.classList.add('activo')
                    //Ocultar menu
                    this.menuFlotante.classList.add('ocultar')

                    /*if (item.dataset.destino === '#modal-unidades') {
                        console.log('pintelas')
                        this.filtrar(this)
                    }*/
                }

            })
        })
        //Cerrar modales
        this.btnsCerrar.forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault()
                let modal = item.parentNode
                modal.classList.remove('activo')
                this.menuFlotante.classList.remove('ocultar')
            })
        })
        //Agregar filtrar

        //Mostrar Apto
        this.btnMostrarApto.addEventListener('click', () => { this.mostrarApto(this) }, false)
        //Mostrar Zonas
        this.btnMostrarZonas.addEventListener('click', () => { this.mostrarZonas(this) }, false)
        //Ver ejemplo de inventario
        console.log('Ejemplo inventario: ', this.inventario[0])
        //Cerrar busqueda
        this.btnCerrarBusqueda.addEventListener('click', () => { this.cerrarBusqueda(this) }, false)
        //Cerrar zonas
        this.btnCerrarZonas.addEventListener('click', () => { this.ocultarZonas(this) }, false)

        //Buscador
        this.buscadorFiltros = document.querySelector('#buscador form');
        this.campo_apto_tit = this.buscadorFiltros.querySelector('#apto_tit');
        this.campo_tipo_tit = this.buscadorFiltros.querySelector('#tipo_tit');
        this.campo_vista = this.buscadorFiltros.querySelector('#vista');
        this.campo_disponibilidad = this.buscadorFiltros.querySelector('#disponibilidad');
        this.campo_torre = this.buscadorFiltros.querySelector('#filtro_torre');
        //

        // this.btnFiltrar.addEventListener('click', () => {
        //     this.filtrar(this)
        // }, false)

        this.buscadorFiltros.addEventListener('submit', () => {
            event.preventDefault()
            this.filtrar(this)
        }, false)

        this.btnLimpiarFiltros.addEventListener('click', () => { this.buscadorFiltros.reset() }, false)

        //Cambiar acabados
        this.modalApto.contenedor.querySelectorAll('.img_planta a').forEach(btn => {
            btn.addEventListener('click', event => {
                event.preventDefault()
                document.querySelector('.img_planta a.activo').classList.remove('activo')
                btn.classList.add('activo')               
               
               this.modalApto.img_planta.querySelector('img.activo').classList.remove('activo')
               document.getElementById(btn.dataset.acabados).classList.add('activo')

            })
        })
    }
    //Cambiar acabados
    
    //Cerrar busqueda temp
    cerrarBusqueda(interaccion) {
        event.preventDefault()

        interaccion.quitarAislamiento(true)

        interaccion.mundo.mascarasProyecto.traverse((child) => {
            if (child.type === "Mesh") {
                child.material = interaccion.materiales.materialesProyecto.mascaras
                child.userData.activo = false
                child.visible = false
                child.layers.disable(1)
            }
        })

        interaccion.modalUnidades.classList.remove('mostrando-resultados')
    }
    // Depende de inventario
    filtrarInventario(interaccion) {

        const filtrosAplicados = document.querySelector('.filtros-aplicados'),
                crearMarca = (etiqueta, valor) => {
                    let li = document.createElement("li");
                    filtrosAplicados.appendChild(li);
                    li.append(`${etiqueta}: ${valor}`)
                }

        if(interaccion.campo_apto_tit.value) {
           crearMarca('Nombre', interaccion.campo_apto_tit.value)
        }

        if(interaccion.campo_tipo_tit.value) {
            crearMarca('Tipo', interaccion.campo_tipo_tit.value)
        }

        if(interaccion.campo_vista.value) {
            crearMarca('Vista', interaccion.campo_vista.value)
        }

        if(interaccion.campo_disponibilidad.value) {
            crearMarca('Disponibilidad', interaccion.campo_disponibilidad.value)
        }
        //Torres
        const torresActivas = interaccion.campo_torre.querySelectorAll('input:checked')

        if(torresActivas.length > 0) torresActivas.forEach(torre=> crearMarca('Torre', torre.value))
        

        const filteredData = [];

        for (let obj of interaccion.inventario) {
            let matches = true;
            // Compara cada atributo del objeto con el valor del filtro correspondiente           
            
            if(interaccion.campo_apto_tit.value) {
                if (interaccion.campo_apto_tit.value && !obj.id.includes(interaccion.campo_apto_tit.value)) matches = false;
            }

            if(interaccion.campo_tipo_tit.value) {
                if (interaccion.campo_tipo_tit.value && obj.tipo_tit.toString() !== interaccion.campo_tipo_tit.value) matches = false;
            }

            if(interaccion.campo_vista.value) {
                if (interaccion.campo_vista.value && obj.vista !== interaccion.campo_vista.value) matches = false;
            }

            if(interaccion.campo_disponibilidad.value) {
                if (interaccion.campo_disponibilidad.value && obj.disponibilidad !== interaccion.campo_disponibilidad.value) matches = false;
            }

            //Por cada torre
            if (torresActivas.length > 0) {
                let torreMatches = false;
                torresActivas.forEach(torre => {
                  if (torre.value && parseInt(obj.torre) === parseInt(torre.value)) {
                    torreMatches = true;
                  }
                });
                if (!torreMatches) {
                  matches = false;
                }
              }

            // Si todos los filtros coinciden, agrega el objeto al arreglo filtrado
            if (matches) filteredData.push(obj);
        }
        // Puedes hacer lo que desees con el arreglo filtrado, por ejemplo, imprimirlo en la consola
        const numResultados = document.getElementById('numResultados')
        numResultados.innerHTML = filteredData.length
        return filteredData
        
        
    }
    filtrar(interaccion) {
        event.preventDefault();
        document.querySelector('.filtros-aplicados').innerHTML = ''
        const inventarioFiltrado = interaccion.filtrarInventario(interaccion);
        //console.log(inventarioFiltrado)

        interaccion.quitarAislamiento();
        //Limpiar máscaras
        interaccion.maqueta.mundo.mascarasProyecto.traverse(child => {
            if (child.type === "Mesh") {
                child.visible = false
                child.layers.disable(1)
                
            }
        })
        interaccion.tablaResultados.innerHTML = ''
        //Consultar json
        for (let i = 0; i < inventarioFiltrado.length; i++) {
            const infoID = inventarioFiltrado[i].id

            //Prender los aptos del JSON
            interaccion.maqueta.mundo.mascarasProyecto.traverse(child => {
                if (child.type === "Mesh") {
                    if (child.userData.id === infoID) {
                        child.visible = true
                        child.layers.enable(1)
                    }
                }
            })
            //Pintar tabla
            const resultado =
                `<tr data-apto="${inventarioFiltrado[i].id}" data-disponibilidad="${inventarioFiltrado[i].disponibilidad}">
                <td>${inventarioFiltrado[i].apto_tit}</td>
                <td>${inventarioFiltrado[i].tipo_tit}</td>                
                <td>${inventarioFiltrado[i].piso}</td>
                <td>${inventarioFiltrado[i].area_ac}</td>
                <td>${inventarioFiltrado[i].vista}</td>
                <td>${inventarioFiltrado[i].disponibilidad}</td> 
            </tr>`

            const tablaResultadosActual = interaccion.tablaResultados.innerHTML
            interaccion.tablaResultados.innerHTML = tablaResultadosActual + resultado
            //Actualizar filasApto
            interaccion.filasApto = document.querySelectorAll('.listado-resultados tbody tr')

            interaccion.filasApto.forEach(item => {
                item.addEventListener('click', () => interaccion.activarFila(event, interaccion), false)
            })
        }
        //Mostrar resultados
        interaccion.modalUnidades.classList.add('mostrando-resultados')

        //Nueva busqueda
        const btnNuevaBusqueda = document.getElementById('btn-nueva-busqueda')
        btnNuevaBusqueda.addEventListener('click', event => {
            event.preventDefault();
            //Mostrar filtros
            interaccion.modalUnidades.classList.remove('mostrando-resultados')
            const filtrosAplicados = document.querySelector('.filtros-aplicados')
            
            filtrosAplicados.innerHTML = ''
        })
    }
    //
    activarFila(e, interaccion) {
        e.preventDefault()
        e.stopPropagation()
        const fila = e.target,
            identificador = fila.dataset.apto
        if (identificador) {
            interaccion.aislarApto(identificador)
        }
    }
    // Depende de inventario
    aislarApto(identificador) {
        //this ya se refiere a Interaccion
        const filasResultados = Array.from(document.querySelectorAll('#modal-unidades tbody tr'))
        //const filasFavoritos = Array.from(document.querySelectorAll('#modal-favoritos tbody tr'))

        if (filasResultados) {
            filasResultados.forEach(fila => fila.classList.remove('activo'))
            this.quitarAislamiento()
            let fila = filasResultados.find(fila => fila.dataset.apto === identificador)
            fila.classList.add('activo')
        }

        this.mundo.mascarasProyecto.traverse((child) => {

            if (child.type === "Mesh") {
                //Limpiar mascaras
                //child.material = this.materiales.materialesProyecto.mascara
                //Poner mascara
                if (child.userData.id === identificador) {
                    child.userData.activo = true
                    child.material = this.materiales.materialesProyecto.mascaraClick

                    this.maqueta.moverCamara(child)
                    //Mostrar tooltip

                    this.tooltipApto.classList.add('activo')
                    this.btnMostrarApto.dataset.destino = identificador
                    //Pintar info
                    let obj = this.inventario.find(obj => obj.id === identificador)

                    this.tool_torre.innerHTML = obj.torre
                    this.tool_apto.innerHTML = obj.apto_tit
                    this.tool_ac.innerHTML = obj.area_ac
                    this.tool_ap.innerHTML = obj.area_ap
                    //this.tool_img.innerHTML = `<img src="${obj.img_planta}" alt="Planta de unidad">`
                    this.tool_img.dataset.tipo_tit = obj.tipo_tit
                    //this.tool_img.innerHTML = `<img src="/static/img/plantas/apto_thumb_tipo_${obj.tipo_tit}.webp" alt="Planta de unidad">`
                    this.tool_img.innerHTML = `<img src="http://techandtonic.co/proyectos/sauces/plantas/apto_thumb_tipo_A.webp" alt="Planta de unidad">`
                }
            }
        })
    }
    //
    quitarAislamiento(animarCamara) {
        this.tooltipApto.classList.remove('activo')
        this.btnMostrarApto.dataset.destino = ''

        const filasResultados = Array.from(document.querySelectorAll('#modal-unidades tbody tr'))
        //const filasFavoritos = Array.from(document.querySelectorAll('#modal-favoritos tbody tr'))

        if (filasResultados) {
            filasResultados.forEach(fila => fila.classList.remove('activo'))
        }

        this.mundo.mascarasProyecto.traverse((child) => {
            if (child.type === "Mesh") {

                if (child.userData.disponibilidad === 'VENDIDO') {
                    child.material = this.materiales.materialesProyecto.mascarasVendido
                } else if (child.userData.disponibilidad === 'OPCIONADO') {
                    child.material = this.materiales.materialesProyecto.mascarasOpcionado
                } else {
                    child.material = this.materiales.materialesProyecto.mascaras
                }
                child.userData.activo = false
                //child.visible = false
            }
        })

        if (animarCamara) {
            const controles = this.camara.controles
            controles.enabled = false
            gsap.to(controles.target, {
                duration: 1,
                x: 0,
                y: 0.75,
                z: 0,
                onUpdate: function () {
                    controles.update();
                },
                onComplete: function () {
                    controles.enabled = true;
                }
            })


        }
    }
    // Depende de inventario
    mostrarApto(interaccion) {

        // Si es por ID se debe usar el de abajo
        const aptoActivo = interaccion.btnMostrarApto.dataset.destino
        let obj = interaccion.inventario.find(obj => obj.id === aptoActivo)
        //Pintar info
        interaccion.modalApto.contenedor.classList.add('activo')
        interaccion.modalApto.apto_tit.innerHTML = obj.apto_tit
        interaccion.modalApto.pre_tit.innerHTML = 'Torre ' + obj.torre
        interaccion.modalApto.suf_tit.innerHTML = 'Apto tipo ' + obj.tipo_tit // Cambió tipo por tipo_tit
        interaccion.modalApto.area_ac.innerHTML = obj.area_ac
        interaccion.modalApto.area_ap.innerHTML = obj.area_ap
        //interaccion.modalApto.img_planta.innerHTML = `<img src="${obj.img_planta}" alt="Planta de unidad">`

        interaccion.modalApto.img_planta.innerHTML = `
        <img id="sin_acabados" class="activo" src="http://techandtonic.co/proyectos/sauces/plantas/apto_tipo_A.webp" alt="Planta de unidad">
        <img id="con_acabados" src="http://techandtonic.co/proyectos/sauces/plantas/apto_tipo_A.webp" alt="Planta de unidad">
        `

        this.modalApto.contenedor.querySelector('.img_planta a[data-acabados="sin_acabados"]').classList.add('activo')
        this.modalApto.contenedor.querySelector('.img_planta a[data-acabados="con_acabados"]').classList.remove('activo')


        //area_b.innerHTML = obj.area_b
        /*interaccion.modalApto.atributos.innerHTML = `<li>Habitaciones: ${obj.habitaciones}</li><li>Baños: ${obj.banos}</li>`
        if (obj.atributos) {
            let atrs = obj.atributos.split(',');
    
            atrs.forEach((item) => {
                let li = document.createElement("li");
                li.innerText = item;
                atributos.appendChild(li);
            })
        }*/
        //Agregar tour
        /*if (obj.tour_url) {
            btnTour.classList.add('visible')
            tourApto.setAttribute('src', obj.tour_url)
        } else {
            btnTour.classList.remove('visible')
            tourApto.setAttribute('src', '')
        }*/
        


        //Recorridos 360
        const modalTour = document.querySelector('#modal-tour'),
            btnTour = document.querySelector('#btn-tour-360'),
            tourApto = document.querySelector('.appicua-tour'),
            btnTourCerrar = modalTour.querySelector('.btn-cerrar-360')
        //Mostrar recorrido
        btnTour.addEventListener('click', (event) => {
            event.preventDefault()
            modalTour.classList.add('activo')
        })
        btnTourCerrar.addEventListener('click', (event) => {
            event.preventDefault()
            modalTour.classList.remove('activo')
            //tourApto.setAttribute('src', '')
        })

        if(obj.tipo_tit === '8A') {
            btnTour.classList.add('visible')
            tourApto.setAttribute('src','https://multimedia.ingeurbe.com/360/robles_flora/apto_tipo1/tour.html')
        } else if (obj.tipo_tit === '9A') {
            btnTour.classList.add('visible')
            tourApto.setAttribute('src', 'https://multimedia.ingeurbe.com/360/robles_flora/apto_tipo2/tour.html')
        } else {
            btnTour.classList.remove('visible')
            tourApto.setAttribute('src','')
        }
    }
    //
    limpiarInfo() {

        this.modalApto.apto_tit.innerHTML = ''
        this.modalApto.area_ac.innerHTML = ''
        this.modalApto.area_ap.innerHTML = ''
        //this.modalApto.area_b.innerHTML = ''
        this.modalApto.atributos.innerHTML = ''
        this.modalApto.img_planta.innerHTML = ''
        //this.modalApto.img_piso.innerHTML = ''
    }
    cargarMascarasZonas() {      
        this.mundo.mascarasZonas.traverse((child) => {            
            if(child.type === 'Mesh') {
                child.material = this.materiales.materialesProyecto.mascarasZonas
                child.visible = true
                child.layers.enable(2)
            }
        });
        
    }
    mostrarZona(zona){
        const zonaSeleccionada = this.infoZonas.find(infoZona => infoZona.name === zona);  
        
        const mostrarPopUp = () => {
            if(zonaSeleccionada) {
                this.modalHotspot.classList.add('activo')  
                this.hotImg.innerHTML = `<img src="http://techandtonic.co/proyectos/sauces/zonas/${zonaSeleccionada.imagen}" alt="Zona Sauces">`
                this.hotLabel.innerHTML = zonaSeleccionada.label
            } else {
                console.log('Error con la información de las zonas. Es posible que el nombre de la máscaras no se encuentre en infoZonas')
            }
        }
        
        this.mundo.mascarasZonas.traverse((child) => {
            if(child.type === 'Mesh') {

                child.userData.activo = false
                child.material = this.materiales.materialesProyecto.mascarasZonas
                
                if(child.name === zonaSeleccionada.name){
                    child.material = this.materiales.materialesProyecto.mascaraHover
                    child.userData.activo = true
                }
            }
        });

        this.listadoZonas.querySelectorAll('li').forEach(item => item.classList.remove('activo'))
        this.listadoZonas.querySelector(`li[data-name='${zonaSeleccionada.name}']`).classList.add('activo')

        const controles = this.camara.controles
        //controles.minDistance = 1
        controles.enabled = false

       gsap.to(this.camara.instancia.position, {
            //gsap.to(controles.target, {
            duration: 1,
            x: zonaSeleccionada.posicion.x,
            y: zonaSeleccionada.posicion.y,
            z: zonaSeleccionada.posicion.z,
            onUpdate: function () {
                controles.update()
            },
            onComplete: function () {                           
                controles.enabled = true
                mostrarPopUp()
            }
        })
        
        
        
    }
    mostrarZonas(interaccion) {
        this.cargarMascarasZonas()
        //Ocultar modelos
        const ocultarElementos = () => {
            this.elementosOcultosConZonasActivas.forEach(elemento => {
                if (elemento.modelo) {
                    elemento.modelo.position.y = 100
                } else {
                    elemento.position.y = 100
                }

                //elemento.modelo.visible = false
                //elemento.modelo.traverse(child => child.visible = false)
            })
        }

        const controles = this.camara.controles
        controles.minDistance = 0.5
        controles.enabled = false

        //Ocultar 

        gsap.to(controles.target, {
            duration: 1,
            x: 0,
            y: 0.24,
            z: 2.0,
            onUpdate: function () {
                controles.update();
            },
            onComplete: function () {
            }
        });

        gsap.to(this.camara.instancia.position, {
            duration: 2,
            x: -0.6471952092738412, 
            y: 1.27350604644191, 
            z: 3.506955339689915,
            onUpdate: function () {
                controles.update()
            },
            onComplete: function () {
                controles.maxDistance = 5.5                
                controles.enabled = true
                //document.querySelector('.hw-zonas').classList.add('activo')
                //ocultarElementos()
            }
        })
    }
    ocultarZonas(interaccion) {
        this.listadoZonas.querySelectorAll('li').forEach(item => item.classList.remove('activo'))
        this.mundo.mascarasZonas.traverse((child) => {
            if(child.type === 'Mesh') {
                child.visible = false
                child.layers.disable(2)
            }
            
        });

        const mostrarElementos = () => {
            this.elementosOcultosConZonasActivas.forEach(elemento => {
                if (elemento.modelo) {
                    elemento.modelo.position.y = 0
                } else {
                    elemento.position.y = 0
                }
                //elemento.modelo.material.visible = true
                //elemento.modelo.traverse(child => child.material.visible = true)
            })
        }
        //mostrarElementos()
        //document.querySelector('.hw-zonas').classList.remove('activo')

        const controles = this.camara.controles
        controles.maxDistance = 10
        
        controles.enabled = false

        gsap.to(controles.target, {
            duration: 1,
            x: -0.1,
            y: 0.75,
            z: -0.1,
            onUpdate: function () {
                controles.update();
            },
            onComplete: function () {
            }
        });

        gsap.to(this.camara.instancia.position, {
            duration: 2,
            x: -4.0,
            y: 3,
            z: 4.0,
            onUpdate: function () {
                controles.update()
            },
            onComplete: function () {
                controles.minDistance = 3.5
                controles.enabled = true
            }
        })
    }
}
